<template>
	<div>
		<div class="container">
			<div class="has-background-primary radius-lg-top p20">
				<div class="columns address-scroll overflow-x is-centered">
					<div v-for="(branch , index) in branches" class="column is-3 addresses mr-auto">
						<a rel="noreferrer" href="#" class="address-block" @click.prevent="changeLoction(branch , index)" :class="{'is-active':index == selected}">
							<i class="icon_location_1  icon-2rem"></i>
							<span class="">{{branch.name}}</span>
						</a>
					</div>
				</div>
			</div>
		</div>
		<gmap-map class="contact-map"
		:center="currentAddress.position"
		:zoom="18"
		map-type-id="terrain"
		:options="options"
		>
		<GmapMarker
		:position="currentAddress.position"
		:clickable="true"
		:draggable="false"
		@click="toggleInfoWindow"
		:icon="markerOptions"
		/>
		<gmap-info-window
		:position="currentAddress.position"
		:opened="infoWinOpen"
		@closeclick="infoWinOpen=false"
		>
		<div class="info-window">
			<p class="has-text-warning has-text-weight-bold is-size-6">{{currentAddress.name}}</p>
		</div>
	</gmap-info-window>
</gmap-map>
</div>
</template>

<script>

export default {
	name: 'Addresses',
    props: {
        branches: {
            required: true
        },
    },
	data() {
		return {
			markerOptions: {
				url: '/front/img/marker.png',
				zIndex: -100
			},

			options: {
				zoomControl: true,
				mapTypeControl: true,
				streetViewControl: true,
				zoomControlOptions: {
					position: 3
				},
				streetViewControlOptions: {
					position: 3
				},
				mapTypeControlOptions: {
					position: 1
				},
				clickableIcons: false
			},
			infoWinOpen:true,
			selected:0,
			currentAddress: {
				name:'',
				address:'',
				position:{
					lat : 0,
					lng : 0
				}
			},
		}
	},
	created : function() {
		if (this.branches.length) {
			this.currentAddress = this.branches[0];
		}
		else{
			this.geolocation();
		}

	},
	methods: {
		geolocation : function() {
			navigator.geolocation.getCurrentPosition((position) => {
				this.currentAddress = {
					name: "لا يوجد عنوان",
					address: "لا يوجد عنوان",
					position:{
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					}
				};
			});
		},
		toggleInfoWindow(){
			this.infoWinOpen = true;
		},
		changeLoction(branch , index){
			this.selected = index;
			this.currentAddress = branch;
		}
	}
}
</script>
